var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 72 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.71588V1H25V5.71269L20 5.71588ZM25 7.28571V23H20.0058V7.28252L25 7.28571Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4057 21.3962C38.4057 22.459 37.6054 22.9904 36.0049 22.9904C30.6705 22.9904 28.0022 20.8978 28 16.7125V13.5655C28 9.37594 30.6661 7.2801 35.9984 7.27797C37.5967 7.27797 38.397 7.80193 38.3992 8.84986V1.78754L44 1V23H38.4057V21.3962ZM38.4057 13.5591C38.4014 12.5133 37.6011 11.9904 36.0049 11.9904C34.4087 11.9904 33.6084 12.5144 33.6041 13.5623V16.7029C33.6041 17.7487 34.4043 18.2716 36.0049 18.2716C37.6054 18.2716 38.4057 17.7476 38.4057 16.6997V13.5591Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47 5.71269V1H52V5.71269H47ZM52 7.28252V23H47V7.28252H52Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.485 14L11.4263 17.056C11.4239 17.2669 11.3751 17.475 11.2827 17.6672C10.989 18.2418 10.2352 18.526 9.02447 18.526H1.80277L1 23H9.01795C14.0108 23 16.6715 21.253 17 17.7589L11.485 14Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.00339L16.1972 11.9983H8.98205C7.47658 11.9983 6.67816 12.4863 6.58678 13.4622C6.58355 13.5039 6.58355 13.5459 6.58678 13.5876V13.6723L6.54762 17H6.52804L6.44972 16.9322L6.12339 16.695L1 12.815C1.32633 8.93833 3.98702 7 8.98205 7L17 7.00339Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4883 14L65.4263 17.0447C65.4239 17.2547 65.3751 17.462 65.2827 17.6536C64.989 18.226 64.2352 18.5091 63.0245 18.5091H55.8028L55 23H63.0179C68.0108 23 70.6715 21.2595 71 17.7784L65.4883 14Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71 7.00339L70.1972 11.9983H62.9821C61.4766 11.9983 60.6782 12.4863 60.5868 13.4622C60.5836 13.5039 60.5836 13.5459 60.5868 13.5876V13.6723L60.5476 17H60.528L60.4497 16.9424L60.1234 16.7052L55 12.815C55.3263 8.93833 57.987 7 62.9821 7L71 7.00339Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.6b0067274a294ad694a369fbcfeffcd8.svg";
export { ForwardRef as ReactComponent };